
import { Vue, Options } from "vue-class-component";
import { ellipsisString, formatDate, formatDateNormal, formatByCountry } from "@/app/infrastructures/misc/Utils";
import checkRolePermission from "@/app/infrastructures/misc/common-library/CheckRolePermission";
import { AccountController } from "@/app/ui/controllers/AccountController";
import router from "../../router";
import { CargoController } from "../../controllers/CargoController";
import { NGenController } from "../../controllers/NGenController";
import { CARGO } from "@/app/infrastructures/misc/RolePermission";
import { CargoData } from "@/domain/entities/Cargo";
import { capitalize } from "@vue/shared";
import Print from "./modules/print.vue";
import { FlagsPermissionCargo } from "@/feature-flags/flags-permission-cargo";
import CalculateTimeDifference from "@/app/infrastructures/misc/common-library/CalculateTimeDifference";
import CargoDispute from "@/app/ui/views/cargo/component/cargo-dispute.vue"
import CargoFilterSection from "./component/cargo-filter-section.vue";
import WidgetDownloadCargo from "./component/widget-download-cargo.vue";

@Options({
  components: { Print, CargoDispute, CargoFilterSection, WidgetDownloadCargo },
  computed: {
    ableToViewDetail() {
      return FlagsPermissionCargo.permission_cargo_detail_view.isEnabled();
    }
  }
})
export default class TabBookingSuccess extends Vue {
  ellipsisString = ellipsisString;
  CalculateTimeDifference = CalculateTimeDifference;
  async created() {
    CargoController.setStartDate(
      new Date(new Date(new Date().setDate(new Date().getDate() - 1))) as Date | null
    );
    CargoController.setEndDate(new Date() as Date | null);
    await this.$nextTick();
  }

  mounted() {
    this.refs = this.$refs;
    CargoController.setCargoStatus("");
    this.fetchLastIdCargo();
    this.startInterval();
    this.$posthog.startSessionRecording();
  }
  unmounted() {
    CargoController.onReset();
    this.stopInterval();
  }

  fetchInterval = null as any;
  startInterval() {
    this.fetchInterval = setInterval(async () => {
      await this.fetchLastIdCargo();
    }, FlagsPermissionCargo.config_interval_auto_refresh_cargo.getValue() * 1000);
  }
  stopInterval() {
    clearInterval(this.fetchInterval);
  }

  get cargoList() {
    return CargoController.cargoData.data;
  }
  lastIdCargo = 0;
  async fetchCargoList() {
    this.isLoading = true;
    await CargoController.fetchCargoList();
    this.isLoading = false;
  }
  async fetchCargoListWithoutLoading() {
     await CargoController.fetchCargoList();
  }
  async fetchLastIdCargo() {
    const newLastIdCargo = await CargoController.fetchLastIdCargoRetryCargo(
      "cargo"
    );
    if (this.lastIdCargo === 0 && newLastIdCargo !== 0) {
      this.lastIdCargo = newLastIdCargo;
    }
    if (this.lastIdCargo === 0 || newLastIdCargo === 0) return;
    if (this.lastIdCargo !== newLastIdCargo) {
      this.lastIdCargo = newLastIdCargo;
      await this.fetchCargoListWithoutLoading();
    }
  }

  // loading
  isLoading = false;

  // error cause
  get errorCause() {
    return CargoController.errorCause;
  }

  get countryCode() {
    return AccountController.accountData?.countryCode ?? "ID";
  }

  formatValueNumber(number: number) {
    return formatByCountry(number, { type: "weight", country: this.countryCode });
  }

  formatDepartureArrival(departureDate: string, arrivalDate: string) {
    return `${this.formatDateCargo(departureDate, "HH:mm")} - ${this.formatDateCargo(arrivalDate, "HH:mm")}`
  }

  formatEstimationDepartureArrival(departureDate: string, arrivalDate: string) {
    return `${this.formatDateCargo(departureDate, "HH:mm", false)} - ${this.formatDateCargo(arrivalDate, "HH:mm", false)}`
  }

  getDiffDay(departureDate: any, arrivalDate: any, splitBy = "T") {
    if (!departureDate || !arrivalDate)return 0
    else {
      return this.$moment(arrivalDate?.split(splitBy)[0]).utcOffset(arrivalDate).diff(this.$moment(departureDate?.split(splitBy)[0]).utcOffset(departureDate), "days");
    }
  }

  handleArrivalDateTime(item: any) {
    const departure = item.cargoType === 'plane' ? item.departureTime : item.departureDate
    const arrival = item.cargoType === 'plane' ? item.arrivalTime : item.arrivalDate
    return `${
      !departure || !arrival
        ? "-"
        : `${this.formatDepartureArrival(departure, arrival)}
            </div>
            ${
              this.getDiffDay(departure, arrival) > 0
                ? `<div class="text-gray-lp-300 px-1 text-10px bg-gray-lp-200 font-medium rounded">+${this.getDiffDay(
                    departure,
                    arrival
                  )} ${this.$t("hari")}</div>
            </div>`
                : ""
            }`
    }`;
  }

  handleEstimationArrivalDateTime(item: any) {
    const departure = item.estimationDepartureDate
    const arrival = item.estimationArrivalDate
    return `${
      !departure || !arrival
        ? "-"
        : `${this.formatEstimationDepartureArrival(departure, arrival)}
            </div>
            ${
              this.getDiffDay(departure, arrival, " ") > 0
                ? `<div class="text-gray-lp-300 px-1 text-10px bg-gray-lp-200 font-medium rounded">+${this.getDiffDay(
                    departure,
                    arrival,
                    " "
                  )} ${this.$t("hari")}</div>
            </div>`
                : ""
            }`
    }`;
  }

  formatDateCargo(date: any, format = "DD MMMM YYYY", isUtcOffset = true): string{
    const offset = this.$moment(date).locale("id").utcOffset(date);
    const withoutOffset = this.$moment(date).locale("id");
    return isUtcOffset ? offset.format(format) : withoutOffset.format(format);
  }

  get DateNow() {
    return this.$moment().format("YYYY-MM-DDTHH:mm:ss");
  }

  get columns() {
    return [
      ...this.columnsFirst,
      ...this.columnsSecond,
      ...this.columnsThird
    ];
  }

  get columnsFirst() {
    return [
      {
        name: "No. Kargo/SMU",
        styleHead: "w-64 text-left whitespace-no-wrap align-middle break-all",
        render: () => {
          return ``;
        },
        "custom-slot": true,
        slotName: "number_cargo"
      },
      {
        name: "Kota asal - tujuan",
        styleHead: "w-56 text-left whitespace-no-wrap align-middle break-all",
        render: () => {
          return ``;
        },
        "custom-slot": true,
        slotName: "origin_destination"
      },
      {
        name: this.$t("No. seri kendaraan/</br>penerbangan"),
        styleHead: "w-60 text-left whitespace-no-wrap align-middle",
        render: (item: CargoData) => {
          return `<div class="flex flex-row items-center gap-x-1 overflow-ellipsis text-left">
          ${ellipsisString(item.vehiclePoliceNumber, 14) || "-"}
          ${item.transit > 0 ? `<div class="text-gray-lp-300 px-1 text-10px bg-gray-lp-200 font-medium rounded">${item.transit}x transit</div>`: ''}
          </div>`;
        }
      },
      {
        name: "ETD/ETA",
        styleHead: "w-56 text-left",
        render: (item: CargoData) => {
          return `
          <div class="flex flex-col gap-1.5 text-sm text-gray-lp-300" >
            
            ${item.estimationDepartureDate ? formatDateNormal(item.estimationDepartureDate, "DD MMMM YYYY") : ''}
            <div class="flex flex-row gap-1 items-center">
            <div class="text-gray-lp-300">
            ${this.handleEstimationArrivalDateTime(item)}
            </div>
          </div>
          `
        }
      },
      {
        name: this.$t("Tanggal dibuat"),
        styleHead: "w-56 text-left whitespace-no-wrap align-middle",
        render: (item: CargoData) => {
          return `<div class="flex flex-col text-sm text-gray-lp-300"><div class="overflow-ellipsis text-left">${this.formatDateCargo(
            item.createdAt, "DD MMMM YYYY, HH:mm"
          )} WIB<div class="truncate text-gray-lp-600 w-32">${
            item.createdBy
          }</div>
            <div>${item.cargoHubName}</div>
          </div>`;
        }
      },
    ]
  }

  get columnsSecond() {
    const columnSecondData = [
      {
        name: "Total STT/koli",
        styleHead: "w-36 text-left whitespace-no-wrap align-middle",
        render: (item: CargoData) => {
          return `<div class="overflow-ellipsis text-left">${item.totalStt}/${item.cargoActualPiece}</div>`;
        }
      },
      {
        name: this.$t("Chargeable/Gross/Volume (kg)"),
        styleHead: "w-72 whitespace-no-wrap align-middle text-left",
        render: (item: CargoData) => {
          return `<div class="overflow-ellipsis text-left">${this.formatValueNumber(
            item.cargoTotalCustomChargeableWeight
          )}kg/${this.formatValueNumber(item.totalActualCargoGrossWeight)}kg/${this.formatValueNumber(item.totalActualCargoVolumeWeight)}kg</div>`;
        }
      },
      {
        name: this.$t("ATD/ATA"),
        styleHead: "w-48 text-left whitespace-no-wrap align-middle",
        render: (item: CargoData) => {
          return `
          <div class="flex flex-col gap-1.5 text-sm text-gray-lp-300" >
            
            ${item.cargoType === "plane" ? item.departureTime ? this.formatDateCargo(item.departureTime, "DD MMMM YYYY") : "" : item.departureDate ? this.formatDateCargo(item.departureDate, "DD MMMM YYYY") : ""}
            <div class="flex flex-row gap-1 items-center">
            <div class="text-gray-lp-300">
            ${this.handleArrivalDateTime(item)}
            </div>
          </div>
          `;
        }
      },
    ]

    if(FlagsPermissionCargo.permission_cargo_dispute_column_enable.isEnabled()) {
      const disputeColumns = [
        {
          name: "Selisih berat",
          styleHead: "w-48 text-left align-center",
          render: (item: CargoData) => {
            return `
            <div class="flex flex-col gap-1 justify-center text-black-lp-100 text-sm">
              <div class="flex flex-row gap-2 items-center">
                ${this.handleIconIsDispute(item.isDisputeFromBagging)}
                Diproses bagging
              </div>
              <div class="flex flex-row gap-2 items-center">
                ${this.handleIconIsDispute(item.isDisputeFromCargo)}
                Diproses kargo
              </div>
            </div>
            `;
          }
        },
      ]
      
      columnSecondData.splice(2, 0, ...disputeColumns)
    }

    return columnSecondData
  }

  get columnsThird() {
    return [
      {
        name: this.$t("Tanggal diubah"),
        styleHead: "w-56 text-left whitespace-no-wrap align-middle",
        render: (item: CargoData) => {
          return `<div class="flex flex-col"><div class="overflow-ellipsis text-left">${item.updatedAt ? this.formatDateCargo(
            item.updatedAt, "DD MMMM YYYY, HH:mm"
          )  + " WIB" : "-"}<div class="truncate text-gray-lp-600 w-32">${
            item.updatedBy
          }</div></div>`;
        }
      },
      {
        name: "Action",
        key: "actionable_column",
        styleHead: "w-28 text-left align-middle",
        showButton: () => true
      }
    ]
  }

  airportDestinationCode(item: CargoData) {
    return item.cargoType === "plane"
      ? `${item.airportDestinationCityCode} - ${item.airportDestinationCityName}`
      : "-";
  }

   airportOriginCode(item: CargoData) {
    return item.cargoType === "plane"
      ? `${item.airportOriginCityCode} - ${item.airportOriginCityName}`
      : "-";
  }

  actionGroupOptions = (item: any) => {
    const groupOptions = [
      {
        icon: "printer",
        label: "Cetak manifest kargo",
        clickFunction: () => {
          this.refs.print.printManifestV2(item.id);
          this.cargoNumber = item.cargoNumber;
        }
      },
      {
        icon: "invoice",
        label: "Cetak label",
        clickFunction: () => {
          this.refs.print.printData(item.id, "label");
          this.cargoNumber = item.cargoNumber;
        }
      },
      {
        icon: "document-download-outline-grey",
        label: "Unduh excel",
        clickFunction: () => {
          this.downloadManifest(item.id);
        }
      },
      {
        icon: "printer",
        label: "AWB Lion Cargo",
        clickFunction: () => {
          this.printAWBLionCargo(item.cargoNumber);
        }
      },
      {
        icon: "download-gray",
        label: "Download EPL",
        clickFunction: () => {
          this.downloadEPL(item.id);
        }
      }
    ];
    if (
      item.cargoType === "plane" &&
      (item.originCityCode === "BTH" || item.destinationCityCode === "BTH")
    ) {
      return groupOptions;
    } else if (item.cargoType === "plane") {
      const options = groupOptions.slice(0, 4);
      const lastOptions = options.pop();

      // pti
      if (FlagsPermissionCargo.permission_cargo_print_pti_pdf.isEnabled()) {
        options.push({
          icon: "print-pti",
          label: "Cetak PTI",
          clickFunction: () => this.printPti(item)
        });
      }

      // sptj elektronik
      if (
        FlagsPermissionCargo.permission_cargo_print_electronic_sptj_pdf.isEnabled() &&
        item.cargoCommodityGroupIsElectronicDg
      ) {
        options.push({
          icon: "print-sptj",
          label: "Cetak SPTJ",
          clickFunction: () => this.printSPTJElektronik(item)
        });
      }

      // sptj non elektronik
      const sptjNonElectronic =
        FlagsPermissionCargo.permission_cargo_print_sptj_pdf.isEnabled() &&
        item.cargoCommodityGroupIsDg &&
        !item.cargoCommodityGroupIsElectronicDg;

      if (sptjNonElectronic) {
        options.push({
          icon: "print-sptj",
          label: "Cetak SPTJ",
          clickFunction: () => this.printSptjNonElectronic(item)
        });
      }

      return [...options, lastOptions];
    }
    return groupOptions.slice(0, 3);
  };

  errorDownloadEpl = false;
  async downloadEPL(id: number) {
    await CargoController.getDownloadData({ id: id, type: "epl" });
  }

  async downloadManifest(id: number) {
    await CargoController.getDownloadData({ id: id, type: "cargo" });
  }

  printAWBLionCargo(AWBNo: number) {
    NGenController.printAWBLionCargo({ AWBNo: AWBNo });
  }

  // Print
  check = null;
  refs: any = "";
  cargoNumber = "";

  async printManifest(item: CargoData) {
    this.refs.print.printData(item.id, "manifest");
    this.cargoNumber = item.cargoNumber;
  }

  async onPrintLabel(item: CargoData) {
    this.refs.print.printData(item.id, "label");
    this.cargoNumber = item.cargoNumber;
  }

  printPti(item: CargoData) {
    this.refs.print.printPtiPdf(item.id);
    this.cargoNumber = item.cargoNumber;
  }

  printSptjNonElectronic(item: CargoData) {
    this.refs.print.printSptjNonElectronic(item.id);
    this.cargoNumber = item.cargoNumber;
  }

  printSPTJElektronik(item: CargoData) {
    this.refs.print.printSPTJElektronik(item.id);
    this.cargoNumber = item.cargoNumber;
  }

  chevronUp: boolean[] = [];

  get pagination() {
    return CargoController.cargoData.pagination;
  }

  get cargoListAvailable() {
    return (
      !this.cargoList.length && !this.isLoading && this.pagination.page === 1
    );
  }

  // detail
  onClickRow(item: CargoData) {
    router.push(
      `/cargo/${encodeURIComponent(item.cargoNumber)}?id=${item.id}`
    );
  }

  handleIconIsDispute(isDispute: boolean) {
    return isDispute ? `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M12 3C9.61305 3 7.32387 3.94821 5.63604 5.63604C3.94821 7.32387 3 9.61305 3 12C3 13.1819 3.23279 14.3522 3.68508 15.4442C4.13738 16.5361 4.80031 17.5282 5.63604 18.364C6.47177 19.1997 7.46392 19.8626 8.55585 20.3149C9.64778 20.7672 10.8181 21 12 21C13.1819 21 14.3522 20.7672 15.4442 20.3149C16.5361 19.8626 17.5282 19.1997 18.364 18.364C19.1997 17.5282 19.8626 16.5361 20.3149 15.4442C20.7672 14.3522 21 13.1819 21 12C21 9.61305 20.0518 7.32387 18.364 5.63604C16.6761 3.94821 14.3869 3 12 3ZM15.3364 10.8364C15.6879 10.4849 15.6879 9.91508 15.3364 9.5636C14.9849 9.21213 14.4151 9.21213 14.0636 9.5636L11.1 12.5272L9.9364 11.3636C9.58492 11.0121 9.01508 11.0121 8.6636 11.3636C8.31213 11.7151 8.31213 12.2849 8.6636 12.6364L10.4636 14.4364C10.8151 14.7879 11.3849 14.7879 11.7364 14.4364L15.3364 10.8364Z" fill="#36B37E"/>
          </svg>` : `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M12 3C9.61305 3 7.32387 3.94821 5.63604 5.63604C3.94821 7.32387 3 9.61305 3 12C3 13.1819 3.23279 14.3522 3.68508 15.4442C4.13738 16.5361 4.80031 17.5282 5.63604 18.364C6.47177 19.1997 7.46392 19.8626 8.55585 20.3149C9.64778 20.7672 10.8181 21 12 21C13.1819 21 14.3522 20.7672 15.4442 20.3149C16.5361 19.8626 17.5282 19.1997 18.364 18.364C19.1997 17.5282 19.8626 16.5361 20.3149 15.4442C20.7672 14.3522 21 13.1819 21 12C21 9.61305 20.0518 7.32387 18.364 5.63604C16.6761 3.94821 14.3869 3 12 3ZM15.3364 10.8364C15.6879 10.4849 15.6879 9.91508 15.3364 9.5636C14.9849 9.21213 14.4151 9.21213 14.0636 9.5636L11.1 12.5272L9.9364 11.3636C9.58492 11.0121 9.01508 11.0121 8.6636 11.3636C8.31213 11.7151 8.31213 12.2849 8.6636 12.6364L10.4636 14.4364C10.8151 14.7879 11.3849 14.7879 11.7364 14.4364L15.3364 10.8364Z" fill="#A7A8AA"/>
          </svg>`
  }

  handleIconCargo(cargoType: string) {
    if (!cargoType) return "";
    else {
      if (cargoType.toLowerCase() === "ship") {
        return '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"> <g id="table-booking_kapal-berhasil"> <g id="Union"> <path d="M5.8335 6.66699C5.37326 6.66699 5.00016 7.04009 5.00016 7.50033V8.33366C5.00016 8.7939 5.37326 9.16699 5.8335 9.16699H6.66683C7.12707 9.16699 7.50016 8.7939 7.50016 8.33366V7.50033C7.50016 7.04009 7.12707 6.66699 6.66683 6.66699H5.8335Z" fill="#4D4D4D"/> <path fill-rule="evenodd" clip-rule="evenodd" d="M4.16683 2.50033C4.16683 2.04009 3.79373 1.66699 3.3335 1.66699C2.87326 1.66699 2.50016 2.04009 2.50016 2.50033V3.33366C2.50016 3.38076 2.50407 3.42694 2.51158 3.47191C1.53463 3.81186 0.833496 4.74088 0.833496 5.83366V9.16699C0.833496 10.5477 1.95278 11.667 3.3335 11.667H7.50016C8.88088 11.667 10.0002 10.5477 10.0002 9.16699V5.83366C10.0002 4.74088 9.29903 3.81186 8.32208 3.47191C8.32959 3.42694 8.3335 3.38076 8.3335 3.33366V2.50033C8.3335 2.04009 7.9604 1.66699 7.50016 1.66699C7.03993 1.66699 6.66683 2.04009 6.66683 2.50033V3.33366H4.16683V2.50033ZM2.50016 5.83366C2.50016 5.37342 2.87326 5.00033 3.3335 5.00033H7.50016C7.9604 5.00033 8.3335 5.37342 8.3335 5.83366V9.16699C8.3335 9.62723 7.9604 10.0003 7.50016 10.0003H3.3335C2.87326 10.0003 2.50016 9.62723 2.50016 9.16699V5.83366Z" fill="#4D4D4D"/> <path d="M4.60225 17.6749L3.7094 13.5083C3.59823 12.9895 3.99369 12.5003 4.52423 12.5003C4.91718 12.5003 5.25673 12.7748 5.33907 13.1591L6.09077 16.667H15.5767L16.5168 12.2801L10.8823 10.8714C10.8504 10.8635 10.8171 10.8635 10.7852 10.8714C10.6083 10.9157 10.4597 10.7132 10.5353 10.5473C10.7269 10.1267 10.8336 9.6593 10.8336 9.16699C10.8336 9.13412 10.8603 9.10725 10.8931 9.10959C10.9317 9.11236 10.9702 9.11781 11.0082 9.12597L14.1669 9.80284V7.50033H11.6669C11.2067 7.50033 10.8336 7.12723 10.8336 6.66699C10.8336 6.20675 11.2067 5.83366 11.6669 5.83366V5.00033H11.1786C10.9137 5.00033 10.6854 4.8124 10.5847 4.56743C10.3814 4.0728 10.7053 3.33366 11.2401 3.33366H12.5003C12.9605 3.33366 13.3336 3.70675 13.3336 4.16699V5.83366H15.0003C15.4605 5.83366 15.8336 6.20675 15.8336 6.66699V10.3913L17.7025 10.8585C18.1384 10.9675 18.4094 11.4023 18.3153 11.8416L17.0653 17.6749C16.9829 18.0592 16.6434 18.3337 16.2504 18.3337H5.41709C5.02414 18.3337 4.68459 18.0592 4.60225 17.6749Z" fill="#4D4D4D"/> <path d="M15.1639 12.9332L10.8338 12.0672L6.50366 12.9332C6.05236 13.0235 5.75968 13.4625 5.84994 13.9138C5.9402 14.3651 6.37922 14.6578 6.83052 14.5675L10.8338 13.7669L14.837 14.5675C15.2883 14.6578 15.7273 14.3651 15.8176 13.9138C15.9078 13.4625 15.6152 13.0235 15.1639 12.9332Z" fill="#4D4D4D"/> </g> </g> </svg>';
      } else if (cargoType.toLowerCase() === "truck") {
        return '<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg"> <g id="ics_o_truck booking"> <g id="Vector"> <path fill-rule="evenodd" clip-rule="evenodd" d="M12.1668 5.00035C11.7066 5.00033 11.3335 5.37343 11.3335 5.83368V15.0003H9.52385C9.40072 14.6521 9.20077 14.3321 8.9346 14.0659C8.46575 13.5971 7.82987 13.3337 7.16683 13.3337C6.50379 13.3337 5.8679 13.5971 5.39906 14.0659C5.13289 14.3321 4.93294 14.6521 4.80981 15.0003H4.66683V13.3337C4.66683 12.8734 4.29373 12.5003 3.8335 12.5003C3.37326 12.5003 3.00016 12.8734 3.00016 13.3337V15.0003C3.00016 15.4424 3.17576 15.8663 3.48832 16.1788C3.80088 16.4914 4.2248 16.667 4.66683 16.667H4.80981C4.93294 17.0152 5.13289 17.3353 5.39906 17.6014C5.8679 18.0703 6.50379 18.3337 7.16683 18.3337C7.82987 18.3337 8.46575 18.0703 8.9346 17.6014C9.20077 17.3353 9.40072 17.0152 9.52385 16.667H11.3335C11.6286 16.667 11.9156 16.5887 12.1668 16.4437C12.418 16.5887 12.7051 16.667 13.0002 16.667H13.1431C13.2663 17.0152 13.4662 17.3353 13.7324 17.6014C14.2012 18.0703 14.8371 18.3337 15.5002 18.3337C16.1632 18.3337 16.7991 18.0703 17.2679 17.6014C17.5341 17.3353 17.7341 17.0152 17.8572 16.667H18.0002C18.4422 16.667 18.8661 16.4914 19.1787 16.1788C19.4912 15.8663 19.6668 15.4424 19.6668 15.0003V11.1785C19.6667 10.7365 19.4911 10.3126 19.1785 10.0001L16.3336 7.15524C16.0211 6.84271 15.5971 6.66709 15.1552 6.66699H13.0002C13.0002 6.47917 13.0002 6.15006 13.0002 5.83363C13.0002 5.3734 12.6271 5.00036 12.1668 5.00035ZM13.1431 15.0003H13.0002V8.33366L15.1551 8.33375L18.0002 11.1788V15.0003H17.8572C17.7341 14.6521 17.5341 14.3321 17.2679 14.0659C16.7991 13.5971 16.1632 13.3337 15.5002 13.3337C14.8371 13.3337 14.2012 13.5971 13.7324 14.0659C13.4662 14.3321 13.2663 14.6521 13.1431 15.0003ZM6.57757 15.2444C6.73385 15.0881 6.94582 15.0003 7.16683 15.0003C7.38784 15.0003 7.5998 15.0881 7.75608 15.2444C7.91236 15.4007 8.00016 15.6126 8.00016 15.8337C8.00016 16.0547 7.91236 16.2666 7.75608 16.4229C7.5998 16.5792 7.38784 16.667 7.16683 16.667C6.94582 16.667 6.73385 16.5792 6.57757 16.4229C6.42129 16.2666 6.3335 16.0547 6.3335 15.8337C6.3335 15.6126 6.42129 15.4007 6.57757 15.2444ZM14.9109 15.2444C15.0672 15.0881 15.2791 15.0003 15.5002 15.0003C15.7212 15.0003 15.9331 15.0881 16.0894 15.2444C16.2457 15.4007 16.3335 15.6126 16.3335 15.8337C16.3335 16.0547 16.2457 16.2666 16.0894 16.4229C15.9331 16.5792 15.7212 16.667 15.5002 16.667C15.2791 16.667 15.0672 16.5792 14.9109 16.4229C14.7546 16.2666 14.6668 16.0547 14.6668 15.8337C14.6668 15.6126 14.7546 15.4007 14.9109 15.2444Z" fill="#4D4D4D"/> <path fill-rule="evenodd" clip-rule="evenodd" d="M3.8335 1.66699C4.29373 1.66699 4.66683 2.04009 4.66683 2.50033V3.33366H7.16683V2.50033C7.16683 2.04009 7.53993 1.66699 8.00016 1.66699C8.4604 1.66699 8.8335 2.04009 8.8335 2.50033V3.33366C8.8335 3.38076 8.82959 3.42694 8.82208 3.47191C9.79903 3.81186 10.5002 4.74088 10.5002 5.83366V9.16699C10.5002 10.5477 9.38087 11.667 8.00016 11.667H3.8335C2.45278 11.667 1.3335 10.5477 1.3335 9.16699V5.83366C1.3335 4.74088 2.03463 3.81186 3.01158 3.47191C3.00407 3.42694 3.00016 3.38076 3.00016 3.33366V2.50033C3.00016 2.04009 3.37326 1.66699 3.8335 1.66699ZM3.8335 5.00033C3.37326 5.00033 3.00016 5.37342 3.00016 5.83366V9.16699C3.00016 9.62723 3.37326 10.0003 3.8335 10.0003H8.00016C8.4604 10.0003 8.8335 9.62723 8.8335 9.16699V5.83366C8.8335 5.37342 8.4604 5.00033 8.00016 5.00033H3.8335ZM5.50016 7.50033C5.50016 7.04009 5.87326 6.66699 6.3335 6.66699H7.16683C7.62707 6.66699 8.00016 7.04009 8.00016 7.50033V8.33366C8.00016 8.7939 7.62707 9.16699 7.16683 9.16699H6.3335C5.87326 9.16699 5.50016 8.7939 5.50016 8.33366V7.50033Z" fill="#4D4D4D"/> </g> </g> </svg>';
      } else if (cargoType.toLowerCase() === 'plane') {
        return '<svg width="20" height="20" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"> <g id="Group 1972"> <g id="Vector"> <path d="M3.89746 12.2751C3.20089 12.3631 2.70551 13.0658 3.26567 13.4891C3.39064 13.5835 3.52896 13.6591 3.67531 13.7093L5.53665 14.3485L6.17576 16.2098C6.36248 16.7536 6.8163 17.1628 7.37647 17.2923C7.93664 17.4219 8.52404 17.2536 8.9306 16.8471L9.51986 16.2578C9.89378 15.8839 10.0681 15.3547 9.98954 14.8318L9.82287 13.7218L10.1767 13.368L11.4429 15.9345C11.6806 16.4164 12.136 16.7541 12.6662 16.8416C13.1963 16.9291 13.7361 16.7556 14.1161 16.3757L15.0589 15.4328C15.4495 15.0422 15.6212 14.4834 15.5173 13.9409L14.5669 8.9778L16.5351 7.00959C17.4841 6.06057 17.6916 4.3948 16.5909 3.29418C15.4903 2.19356 13.8245 2.40099 12.8755 3.35L11.2124 5.0314C10.9737 5.27267 10.8399 5.59833 10.8399 5.93768C10.8399 6.55597 11.2883 6.93451 11.8236 6.62516C12.0158 6.51411 12.1774 6.40426 12.2463 6.33536L14.054 4.52852C14.4453 4.13725 15.052 4.11232 15.4124 4.47269C15.7728 4.83307 15.7479 5.43982 15.3566 5.83108L13.0761 8.11155C12.8808 8.30685 12.795 8.58625 12.8469 8.85753L13.8804 14.2543L12.9375 15.1971L11.157 11.5879C10.9045 11.0761 10.2239 10.9638 9.82038 11.3673L8.34709 12.8406C8.16013 13.0275 8.07299 13.2921 8.11225 13.5536L8.34135 15.0793L7.75209 15.6685L6.84841 13.0367L4.43317 12.3189C4.25957 12.2673 4.07714 12.2524 3.89746 12.2751Z" fill="#4D4D4D"/> <path fill-rule="evenodd" clip-rule="evenodd" d="M3.1665 0.666992C3.62674 0.666992 3.99984 1.04009 3.99984 1.50033V2.33366H6.49984V1.50033C6.49984 1.04009 6.87293 0.666992 7.33317 0.666992C7.79341 0.666992 8.1665 1.04009 8.1665 1.50033V2.33366C8.1665 2.38076 8.1626 2.42694 8.15509 2.47191C9.13204 2.81186 9.83317 3.74088 9.83317 4.83366V8.16699C9.83317 9.5477 8.71388 10.667 7.33317 10.667H3.1665C1.78579 10.667 0.666504 9.5477 0.666504 8.16699V4.83366C0.666504 3.74088 1.36763 2.81186 2.34459 2.47191C2.33708 2.42694 2.33317 2.38076 2.33317 2.33366V1.50033C2.33317 1.04009 2.70627 0.666992 3.1665 0.666992ZM3.1665 4.00033C2.70627 4.00033 2.33317 4.37342 2.33317 4.83366V8.16699C2.33317 8.62723 2.70627 9.00033 3.1665 9.00033H7.33317C7.79341 9.00033 8.1665 8.62723 8.1665 8.16699V4.83366C8.1665 4.37342 7.79341 4.00033 7.33317 4.00033H3.1665ZM4.83317 6.50033C4.83317 6.04009 5.20627 5.66699 5.6665 5.66699H6.49984C6.96007 5.66699 7.33317 6.04009 7.33317 6.50033V7.33366C7.33317 7.7939 6.96007 8.16699 6.49984 8.16699H5.6665C5.20627 8.16699 4.83317 7.7939 4.83317 7.33366V6.50033Z" fill="#4D4D4D"/> </g> </g> </svg>';
      } else {
        return "";
      }
    }
  }

  handleFlagIcon(item: CargoData) {
    return `${
        item.cargoType === "plane" && item.cargoCommodityGroupIsDg
          ? `
          <span
            v-if="item.isDangerousGoods"
            class="ml-1 bg-red-lp-600 rounded text-center text-red-lp-1600 font-medium text-xs px-1"
          >
            DG
          </span>`
          : ""
      }
      ${
      item.cargoType === "plane" && item.cargoCommodityGroupIsQuarantine
        ? `
          <span
            class="bg-yellow-lp-200 rounded text-center text-yellow-lp-100 font-medium text-xs px-1"
          >
            K
          </span>`
        : ""
  }`;
  }

  handleShowRemainingTimePlane(time: string, cargoType: string, departureDate: string) {
    if (!time || cargoType !== 'plane' || departureDate ) return ""
    return `<div class="bg-yellow-lp-200 px-2 rounded-xl text-14px text-yellow-lp-100 mt-2 ml-5 inline-flex">
              <div class="pt-0.5 pr-1">
                <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M8.0001 3.83325C7.07712 3.83325 6.17487 4.10695 5.40744 4.61973C4.64001 5.13251 4.04187 5.86134 3.68866 6.71406C3.33545 7.56678 3.24304 8.5051 3.4231 9.41034C3.60316 10.3156 4.04762 11.1471 4.70027 11.7998C5.35291 12.4524 6.18443 12.8969 7.08968 13.0769C7.99492 13.257 8.93323 13.1646 9.78595 12.8114C10.6387 12.4581 11.3675 11.86 11.8803 11.0926C12.3931 10.3252 12.6668 9.4229 12.6668 8.49992C12.6668 7.26224 12.1751 6.07526 11.2999 5.20009C10.4248 4.32492 9.23777 3.83325 8.0001 3.83325ZM7.33343 2.49992V2.53707C7.1649 2.55591 6.99679 2.58194 6.82956 2.61521C5.66567 2.84672 4.59657 3.41816 3.75746 4.25728C2.91834 5.09639 2.3469 6.16549 2.11539 7.32938C1.88388 8.49326 2.0027 9.69966 2.45682 10.796C2.91095 11.8924 3.67998 12.8294 4.66668 13.4887C5.65337 14.148 6.81341 14.4999 8.0001 14.4999C9.5914 14.4999 11.1175 13.8678 12.2427 12.7426C13.368 11.6173 14.0001 10.0912 14.0001 8.49992C14.0001 7.31323 13.6482 6.15319 12.9889 5.1665C12.3296 4.1798 11.3926 3.41077 10.2962 2.95664C9.77261 2.73977 9.22393 2.59936 8.66676 2.53707V2.49992C8.66676 2.32311 8.59653 2.15354 8.4715 2.02851C8.34648 1.90349 8.17691 1.83325 8.0001 1.83325C7.82329 1.83325 7.65372 1.90349 7.52869 2.02851C7.40367 2.15354 7.33343 2.32311 7.33343 2.49992ZM10.6668 9.49992H8.0001C7.82329 9.49992 7.65372 9.42968 7.52869 9.30466C7.40367 9.17963 7.33343 9.01006 7.33343 8.83325V5.83325C7.33343 5.65644 7.40367 5.48687 7.52869 5.36185C7.65372 5.23682 7.82329 5.16659 8.0001 5.16659C8.17691 5.16659 8.34648 5.23682 8.4715 5.36185C8.59653 5.48687 8.66676 5.65644 8.66676 5.83325V8.16659H10.6668C10.8436 8.16659 11.0131 8.23682 11.1382 8.36185C11.2632 8.48687 11.3334 8.65644 11.3334 8.83325C11.3334 9.01006 11.2632 9.17963 11.1382 9.30466C11.0131 9.42968 10.8436 9.49992 10.6668 9.49992ZM1.63343 5.05325C1.74079 5.12845 1.86903 5.16808 2.0001 5.16659C2.1099 5.16602 2.21787 5.13834 2.3144 5.086C2.41093 5.03366 2.49304 4.95829 2.55343 4.86659C2.83869 4.43149 3.20543 4.0557 3.63343 3.75992C3.77766 3.67313 3.88373 3.53499 3.93033 3.37324C3.97692 3.21149 3.96061 3.0381 3.88465 2.88788C3.8087 2.73766 3.67873 2.62173 3.52084 2.56337C3.36295 2.50501 3.18883 2.50854 3.03343 2.57325C2.39752 2.97184 1.85607 3.50418 1.44677 4.13325C1.35028 4.28023 1.31576 4.45937 1.35072 4.63168C1.38568 4.80398 1.48729 4.9555 1.63343 5.05325ZM14.0001 5.16659C13.8909 5.16675 13.7833 5.14009 13.6868 5.08894C13.5904 5.03779 13.5079 4.96373 13.4468 4.87325C13.1648 4.43369 12.7976 4.05511 12.3668 3.75992C12.2225 3.67313 12.1165 3.53499 12.0699 3.37324C12.0233 3.21149 12.0396 3.0381 12.1155 2.88788C12.1915 2.73766 12.3215 2.62173 12.4794 2.56337C12.6372 2.50501 12.8114 2.50854 12.9668 2.57325C13.6027 2.97184 14.1441 3.50418 14.5534 4.13325C14.6506 4.27942 14.6861 4.458 14.6524 4.63023C14.6187 4.80247 14.5185 4.95447 14.3734 5.05325C14.2619 5.12499 14.1327 5.16424 14.0001 5.16659Z" fill="#F09035"/>
                </svg>
              </div>
             ${time}
            </div>`
  }

  get shouldShowSummary() {
    return FlagsPermissionCargo.permission_cargo_dispute_summary_enable.isEnabled()
  }

  onHandleFilter() {
    this.fetchCargoList();
    CargoController.getCargoSuccessSummary()
    if(this.shouldShowSummary) {
      CargoController.getCargoDisputeSummary()
      CargoController.getCargoMinimumWeightSummary()
    }
  }

  showRemainingTimePlane(
    time: string,
    cargoType: string,
    departureDate: string
  ) {
    return !(!time || cargoType !== "plane" || departureDate);
  }
}
